"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-one/sections/articleSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ArticleSection6sItem = {
    key: Key | null | undefined;
    /** Detected variants: "15" | "18" */
    span0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/blog/article-01.jpg" | "/Templates/Doccure/img/blog/article-02.jpg" */
    src: string;
    /** Detected variants: "Understanding and Preventing Glaucoma: A Detailed Guide" | "Neurology & Technology: A New Frontier in Brain" */
    link0Text: ReactNode;
    /** Detected variants: "Glaucoma is a leading cause of blind worldwide, yet many...." | "Discover the intersection of technology and neurology, transforming...." */
    p0Text: ReactNode;
    /** Detected variants: "Treatments" | "Neurology" */
    span0Span0Text: ReactNode;
    /** Detected variants: "col-lg-6" */
    className?: string;
    /** Detected variants: "article-item wow fadeOutDown" */
    div0ClassName?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "article-img" */
    div0ClassName2?: string;
    /** Detected variants: "May" */
    div0Text?: ReactNode;
    /** Detected variants: "date-icon" */
    div0ClassName3?: string;
    /** Detected variants: "all_routes.blogDetails" */
    href?: string;
    /** Detected variants: "img" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "article-info" */
    div1ClassName?: string;
    /** Detected variants: "mb-1 custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.blogDetails" */
    link0Href?: string;
    /** Detected variants: "Read More" */
    link0Link0Text?: ReactNode;
    /** Detected variants: "link" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    link0Href2?: string;
    /** Detected variants: "badge badge-cyan mb-2" */
    span0ClassName?: string;
};
export type HomeOneArticleSectionGeneratedProps = {
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ArticleSection6sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ArticleSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ArticleSection6sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ArticleSection6sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ArticleSection6sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Recent Blogs" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Stay Updated With Our" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Latest Articles" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div2DivDataWowDuration?: string;
    /** Default: "all_routes.blogGrid" */
    sectionDiv0Div2Link0LinkHref?: string;
    /** Default: "View All Articles" */
    sectionDiv0Div2Link0LinkText?: ReactNode;
    sectionDiv0Div2Link0LinkVisible?: boolean;
    sectionDiv0Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    articleSection6s: ArticleSection6sItem[];
    articleSection6sItemWrapper?: (item: ArticleSection6sItem, content: ReactNode) => ReactNode;
    articleSection6sRenderer?: (defaultNode: ReactNode) => ReactNode;
    articleSection6sLinkVisible?: boolean;
    articleSection6sLinkRenderer?: (item: ArticleSection6sItem, defaultNode: ReactNode) => ReactNode;
    articleSection6sImageVisible?: boolean;
    articleSection6sImageRenderer?: (item: ArticleSection6sItem, defaultNode: ReactNode) => ReactNode;
    articleSection6sH3Visible?: boolean;
    articleSection6sH3Renderer?: (item: ArticleSection6sItem, defaultNode: ReactNode) => ReactNode;
    articleSection6sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ArticleSection6sItem) => Partial<ComponentProps<typeof SmartLink>>);
    articleSection6sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ArticleSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    articleSection6sH3Props?: Partial<ComponentProps<"h3">> | ((item: ArticleSection6sItem) => Partial<ComponentProps<"h3">>);
};

const HomeOneArticleSectionGenerated: FC<HomeOneArticleSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Recent Blogs",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Stay Updated With Our",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Latest Articles",
    sectionDiv0Div2DivDataWowDuration = "1s",
    sectionDiv0Div2Link0LinkHref = "all_routes.blogGrid",
    sectionDiv0Div2Link0LinkText = "View All Articles",
    sectionDiv0Div2Link0LinkVisible,
    sectionDiv0Div2Link0LinkRenderer,
    sectionDiv0Div2Link0LinkProps,
    divDiv0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    divDiv0Div1Link0LinkProps,
    sectionDiv0Div1ClassName,
    articleSection6s,
    articleSection6sItemWrapper,
    articleSection6sRenderer,
    articleSection6sLinkVisible,
    articleSection6sLinkRenderer,
    articleSection6sImageVisible,
    articleSection6sImageRenderer,
    articleSection6sH3Visible,
    articleSection6sH3Renderer,
    articleSection6sLinkProps,
    articleSection6sImageProps,
    articleSection6sH3Props,
}) => {
    return (
        <section className="article-section section">
            <div className="container">
                <div className="section-header section-header-one text-center wow slideInLeft" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {" "}
                            {sectionDiv0Div0H20H2Text}
                            {" "}
                            <span className="text-primary">{sectionDiv0Div0H20Span0SpanText}</span>
                            {" "}
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        articleSection6s,
                        (item: ArticleSection6sItem) => (
                            <div className={item.className ?? "col-lg-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "article-item wow fadeOutDown"} data-wow-duration={item.dataWowDuration ?? "1s"}>
                                    <div className={item.div0ClassName2 ?? "article-img"}>
                                        {renderItemNode(articleSection6sLinkVisible, articleSection6sLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "all_routes.blogDetails"} {...(typeof articleSection6sLinkProps === "function" ? articleSection6sLinkProps(item) : (articleSection6sLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                {renderItemNode(articleSection6sImageVisible, articleSection6sImageRenderer, item, (
                                                    <SmartImage src={item.src} className={item.imageWithBasePath0ClassName ?? "img-fluid"} alt={item.alt ?? "img"} {...(typeof articleSection6sImageProps === "function" ? articleSection6sImageProps(item) : (articleSection6sImageProps ?? {}))} {...(typeof divDiv0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                        <div className={item.div0ClassName3 ?? "date-icon"}>
                                            <span>{item.span0Text}</span>
                                            {item.div0Text ?? "May"}
                                        </div>
                                    </div>
                                    <div className={item.div1ClassName ?? "article-info"}>
                                        <span className={item.span0ClassName ?? "badge badge-cyan mb-2"}>{item.span0Span0Text}</span>
                                        {renderItemNode(articleSection6sH3Visible, articleSection6sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "mb-1 custom-title"} {...(typeof articleSection6sH3Props === "function" ? articleSection6sH3Props(item) : (articleSection6sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(articleSection6sLinkVisible, articleSection6sLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href ?? "all_routes.blogDetails"} {...(typeof articleSection6sLinkProps === "function" ? articleSection6sLinkProps(item) : (articleSection6sLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                        {renderItemNode(articleSection6sLinkVisible, articleSection6sLinkRenderer, item, (
                                            <SmartLink href={item.link0Href2 ?? "#"} className={item.link0ClassName ?? "link"} {...(typeof articleSection6sLinkProps === "function" ? articleSection6sLinkProps(item) : (articleSection6sLinkProps ?? {}))} {...(typeof divDiv0Div1Link0LinkProps === "function" ? divDiv0Div1Link0LinkProps(item) : (divDiv0Div1Link0LinkProps ?? {}))}>{item.link0Link0Text ?? "Read More"}</SmartLink>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ),
                        articleSection6sItemWrapper,
                        articleSection6sRenderer
                    )}
                </div>
                <div className="text-center load-item wow fadeOutDown" data-wow-duration={sectionDiv0Div2DivDataWowDuration}>
                    {renderNode(sectionDiv0Div2Link0LinkVisible, sectionDiv0Div2Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div2Link0LinkHref} className="btn btn-dark d-inline-flex align-items-center" {...(sectionDiv0Div2Link0LinkProps ?? {})}>
                            {sectionDiv0Div2Link0LinkText}
                            <i className="isax isax-arrow-right-3 ms-2" />
                        </SmartLink>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HomeOneArticleSectionGenerated;
